import React, { useEffect, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EyeIcon from '@assets/svg_main/eye-outline.svg';
import EditIcon from '@assets/svg_main/edit_outline.svg';
import { useSelector } from 'react-redux';
import TooltipComponent from '@components/common/TooltipComponent';
import axios from '../../../../utils/axiosExt';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setDistrictByZoneId, setZoneByZoneId, setHealthBlockById, setDistrictByStateId, setVillagesByBlockId, setWardsByUlbId } from "../../../../store/actions/zoneDetailsActions";
import { errorLogger } from '@utils/applicationLogUtils';
import endpoints from "../../../../config/endpoints";
import {
  setBlockByHealthBlockId, setULBByHealthBlockId, setSubDistrictByHealthBlockId, setVillageByHealthBlockId, setWardByHealthBlockId,
  setSubDistrictByDistrict,
  setBlockByDistrict,
  setUlbByState
} from '@store/actions/healthBlockActions';
import { PagePermission } from './../../../../services/usePermission';
import Auth from '../../../../utils/auth';

const ActionComponent = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let pathname =location.pathname.split('/')[1];//String(storeData.GeoNonGeoData.currentTab.split("/")[0]).toLocaleLowerCase().replaceAll(" ", "");
  const storeData = useSelector(state => state);
  const dispatch = useDispatch();
  const canEdit =pathname==="zone"?PagePermission("GeoNG_ZDC", "GeoNG_ZDC_EdPg"): PagePermission("GeoNG_HBSD", "GeoNG_HBSD_EdPg");
  const canView =pathname==="zone"?PagePermission("GeoNG_ZDC", "GeoNG_ZDC_OVPg"): PagePermission("GeoNG_HBSD", "GeoNG_HBSD_OVPg");
  let  healthBlockById;
  let ulbByHealthBlockId;
  let ULB_ID;
  let blockByHealthBlockId;
  let BLOCK_ID;
  let subDistrictByHealthBlockId;
  let villagesByHealthBlockId;
  let getVilageByBlockId;
  let wardsByHealthBlockId;
  let getWardByUlbId;
  let stateId;
  let getStateByDistrict;
  const fetchAPI = async (pathname) => {
    let { id, mapped_village_count, mapped_wards_count } = user;
    if (id) {
      if (pathname === 'zone') {
        try {
          const districtByZoneId = await axios.get(`${endpoints.getDistrictsByZDCId(id)}`, Auth.loggedIn());
          dispatch(setDistrictByZoneId(id, districtByZoneId?.data?.data));
        }
        catch (e) {
          dispatch(setDistrictByZoneId(id, []));
        }
        try {

          const zoneByZoneId = await axios.get(`${endpoints.getZoneDivCircleByZDCId(id)}`, Auth.loggedIn());
          dispatch(setZoneByZoneId(id, zoneByZoneId?.data?.data));
          try{
             stateId = zoneByZoneId?.data?.data[0]?.st_id;
          }
          catch(error){
            errorLogger(error?.response?.data||error?.response||error)
          }
          try{
             getStateByDistrict = await axios.get(`${endpoints.getDistrictsforZoneByStateId(stateId)}`, Auth.loggedIn());
          }
          catch(error){
                 errorLogger(error?.response?.data||error?.response||error)
          }
          dispatch(setDistrictByStateId(stateId, getStateByDistrict?.data?.data))
        }
        catch (e) {
          dispatch(setZoneByZoneId(id, []));
        }

      }
      if (pathname === 'healthblock') {
        try{
         healthBlockById = await axios.get(`${endpoints.getHealthBlockandSubDivByHBSDId(id)}`, Auth.loggedIn());
        }
        catch(error){
          errorLogger(error?.response?.data||error?.response||error)
        }
        try{
         ulbByHealthBlockId = await axios.get(`${endpoints.getULBbyHbsdId(id)}`, Auth.loggedIn());
         ULB_ID = ulbByHealthBlockId?.data?.data[0]?.ulb_id;
        }
        catch(error){
          errorLogger(error?.response?.data||error?.response||error)
        }
        try{
           blockByHealthBlockId = await axios.get(`${endpoints.getblockHbsdId(id)}`, Auth.loggedIn());
           BLOCK_ID = blockByHealthBlockId?.data?.data[0]?.block_id;
        }
        catch(error){
          errorLogger(error?.response?.data||error?.response||error)
        }
       try{
         subDistrictByHealthBlockId = await axios.get(`${endpoints.getSubDistrictbyHbsdId(id)}`, Auth.loggedIn());
       }
       catch(error){
        errorLogger(error?.response?.data||error?.response||error)
      }
        if (mapped_village_count) {
          try{
             villagesByHealthBlockId = await axios.get(`${endpoints.getVillagesByHBSDId(id)}`, Auth.loggedIn());
          }
          catch(error){
            errorLogger(error?.response?.data||error?.response||error)
          }
          try{
            if(BLOCK_ID){
              getVilageByBlockId = await axios.get(`${endpoints.getVillageByBlockId(BLOCK_ID)}`, Auth.loggedIn());
            }
          }
          catch(error){
            errorLogger(error?.response?.data||error?.response||error)
          }
          dispatch(setVillagesByBlockId(BLOCK_ID, getVilageByBlockId?.data?.data));
          dispatch(setVillageByHealthBlockId(id, villagesByHealthBlockId?.data?.data));
        }

        if (mapped_wards_count) {
          try{
             wardsByHealthBlockId = await axios.get(`${endpoints.getWardsByHBSDId(id)}`, Auth.loggedIn());
          }
          catch(error){
            errorLogger(error?.response?.data||error?.response||error)
          }
          try{
             getWardByUlbId = await axios.get(`${endpoints.getWard(ULB_ID)}`, Auth.loggedIn());
          }
          catch(error){
            errorLogger(error?.response?.data||error?.response||error)
          }
          dispatch(setWardsByUlbId(ULB_ID, getWardByUlbId?.data?.data))
          dispatch(setWardByHealthBlockId(id, wardsByHealthBlockId?.data?.data));
        }
        dispatch(setHealthBlockById(id, healthBlockById?.data?.data));
        dispatch(setULBByHealthBlockId(id, ulbByHealthBlockId?.data?.data));
        dispatch(setBlockByHealthBlockId(id, blockByHealthBlockId?.data?.data));
        dispatch(setSubDistrictByHealthBlockId(id, subDistrictByHealthBlockId?.data?.data));
        await fetchListById();

      }
      /**
      getUlb
      getbLOCK
      getVillageByBlockId
      getSubDistrict
      getWardByHealthDivisionId
  
       */
    }
  }

  const fetchListById = async () => {
    const STATE_ID = '42629363-b71b-4d32-86fa-167ecfe440e7';
    const DISTRICT_ID = '8a7d660c-8894-4680-b14c-e28132d2c15a';
    const subDistrictByDistrictId = await axios.get(`${endpoints.getSubDistricts(DISTRICT_ID)}`, Auth.loggedIn());
    const blockByDistrictId = await axios.get(`${endpoints.getBlock(DISTRICT_ID)}`, Auth.loggedIn());
    const ulbByStateId = await axios.get(`${endpoints.getUlb(STATE_ID)}`, Auth.loggedIn());
    dispatch(setSubDistrictByDistrict(DISTRICT_ID, subDistrictByDistrictId?.data?.data));
    dispatch(setBlockByDistrict(DISTRICT_ID, blockByDistrictId?.data?.data));
    dispatch(setUlbByState(STATE_ID, ulbByStateId?.data?.data));

  }

  // useEffect(() => {
  //     fetchAPI();
  // }, []);


  // if (user?.type_name === "Health Block") {
  //   pathname = "healthblock"
  // }

  const getSubUrl = () => {
    let subUrl = user.zoneUrl;
    if (user?.type_name === "Health Block" ||user?.type_name === "health-block"||user?.type_name === "Sub Division"||user?.type_name === "sub-division"|| user?.type) {
      
      subUrl = user.id;
    }
    return subUrl;
  }
  const goToEditPage = async () => {
    //await fetchAPI(pathname);
    navigate(`/${pathname}/edit/${getSubUrl()}`, {
      state: JSON.stringify(user),
    });
  };

  const goToViewPage = async () => {
   // await fetchAPI(pathname);
    navigate(`/${pathname}/view/${getSubUrl()}`, {
      state: JSON.stringify(user),
    });
  };

  return (
    <div className="actionWrapper">
      {canEdit &&(
        <TooltipComponent text="Edit" >
          <EditIcon onClick={goToEditPage} />
        </TooltipComponent>
      )} 
      {canView  &&(
        <TooltipComponent text="View">
          <EyeIcon onClick={goToViewPage} />
        </TooltipComponent>
      )}
    </div>
  );
};

export default ActionComponent;
